import { CardContent as CardContentTypes } from '@/schemas/sceneDataSchema';
import { CardContent as MuiCardContent, styled } from '@mui/material';
import { ReactNode } from 'react';

interface CardContentProps {
  id?: string | null | undefined;
  component: CardContentTypes;
  children: ReactNode;
}

export function CardContent({ id, component, children }: CardContentProps) {
  return (
    <StyledCardContent
      id={id ?? undefined}
      padding={component.padding}
    >
      {children}
    </StyledCardContent>
  );
}

interface CardContentStyledProps {
  padding: 'small' | 'large';
}

const StyledCardContent = styled(MuiCardContent, {
  shouldForwardProp: (prop) => prop !== 'padding',
})<CardContentStyledProps>`
  --card-content-padding: ${({ padding }) => {
    switch (padding) {
      case 'small':
        return '16px';
      case 'large':
        return 'min(46px, 4vw)';
      default:
        return '16px';
    }
  }};

  padding: var(--card-content-padding);
  /* This resolves issues with MUI's uneven CardContent padding rules. */
  &:last-child {
    padding-bottom: var(--card-content-padding);
  }
`;
